<template>
	<el-dialog
		:visible.sync="isShow"
		width="12.15rem"
		id='ZJ_dialog'
		:show-close='true'
		:lock-scroll='false'
	>	
		<div class='ZJ_dialog_title' slot='title'>
			<span>资金进出明细</span>	
			<span>*账面明细记录由会计的记账而产生，仅供参</span>	
		</div>
		<div class='ZJ_dialog_form'>
			<el-form :inline="true" :model='form'>
				<el-form-item>
					<el-select v-model='form.subjectId' placeholder='请选择' size='mini' @change='handleSelectChange' filterable style='width: 160px;'>
						<el-option v-for='item in getSubjectTreeList' :value='item.id' :label='item.name' :key='item.id'></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-date-picker
				      v-model="date.yearPeriodsStart"
				      type="date"
				      size='mini'
				      style='width:140px;'
				      @change='handleDateChangeDate("1")'
				      placeholder="选择日期">
				    </el-date-picker>
				    至
				    <el-date-picker
				      v-model="date.yearPeriodsEnd"
				      type="date"
				       @change='handleDateChangeDate("2")'
				      style='width:140px;'
				      size='mini'
				      :picker-options='disAbleEnd'
				      placeholder="选择日期">
				    </el-date-picker>
				</el-form-item>
				<!-- <el-form-item >
					<div class='Lately_date'>
						最近：
						<span>一周</span>
						<span>一个月</span>
						<span>一年</span>
						<span>按月份选择<i class='el-icon-arrow-down'></i></span>
					</div>
				</el-form-item> -->
			</el-form>
		</div>
		<div class='JCZ_item'>
			<ul class='JCZ_item_ul'>
				<li v-for='item in JCXlist' :key='item.id' :class='nowID==item.id?"active_jcz":""' @click='handleCilckChange(item)' class='JCZ_item_li' v-if='item.isShow'>
					{{item.name}}  {{item.money}}
				</li>
			</ul>
			<public-table :table="tableData" @onHandlePaginationChange="handlePaginationChange"></public-table>
		</div>
	</el-dialog>
</template>
<script>
	import publicTable from '@/components/publicTable'
	import {currencys} from '@/assets/utils/currencyFormat'
	export default {
		props: {
			showVisible: Boolean,
			nowTypeID: String,
			nowTypeID_money: Number,
			period_date_start: Number,
			period_date_end: Number,
		},
		components: {
			publicTable,
		},
		data() {
			return {
				disAbleEnd:{
					disabledDate:(time)=>{
						let standard = this.date.yearPeriodsStart;
						if(standard) {
							return time.getTime()<standard;
						}
					}
				},
				getSubjectTreeList: [],      // 科目列表
				date:{
					yearPeriodsStart: '',
					yearPeriodsEnd: '',
				},            // 会计期间数据
				form:{
					currentPage: 1,
					maxResult: 10,
					startTime: '',		// 开始时间
					endTime: '',  // 结束时间
					subjectId: '',   // 科目ID
					accountType: '',  // 进出账类型
				},
				JCXlist:[
					{name: '进账' ,id: 11 , money: 0 , accountType:'1',isShow: true,  },
					{name: '出账' ,id: 22 ,money: 0 , accountType:'2' , isShow: true},
				],
				nowID: null,
				value1: '',
				tableData: {
					border: true,				// 是否带有纵向边框
					isNotSuspensionShow: true,  // 不显示悬浮效果
					stripe: true,				// 是否带有斑马纹
					loading: false,				// 是否显示加载动画
					hasSelect: false,			// 是否显示多选
					hasOperation: false,		// 是否有操作功能
					hasContextmenu: false,		// 是否有右键功能
					hasShowSummary: false,		// 是否显示合计行
					hasShowPagination: false,	// 是否显示分页
					config: [{
						label: '日期',
						value: 'time',
						show: 'normal'
					},{
						label: '名称',
						value: 'summary',
						show: 'normal'
					},{
						label: '收入(元)',
						value: 'debit_money',
						show: 'normal',
					},{
						label: '支出(元)',
						value: 'creditor_money',
						show: 'normal',
					},{
						label: '余额(元)',
						value: 'remaining_sum',
						show: 'normal'
					},{
						label: '账面类型',
						value: 'accountBookType',
						show: 'normal'
					}],
					data: [],
					page: {
						pageNo: 1,
						pageSize: 20,
						count: 10
					},
					operation: {
						label: '操作',
						value: 'operation',
						width: 160,
						data: [
						{
							label:"编辑",
							value:'editBtn'
						},{
							label:"删除",
							value:'delete'
						}]
					},
					center: {
						textAlign: 'center',
						padding: '6px 0'
					}
				},
				inAccountTotal:'',  // 进账
				outAccountTotal: '', // 出账
			}
		},
		created() {
		},
		computed: {
			// 显示弹窗
			isShow: {
				get () {
					return this.showVisible;
				},
				set (val) {
					this.$emit('update:showVisible', val);
				}
			},
		},
		methods: {
			// 日期改变
			handleDateChangeDate(type) {
				if(type==1) {
					let month = this.date.yearPeriodsStart.getMonth()+1;
					let year = this.date.yearPeriodsStart.getFullYear();
					let oneDay = 1000*60*60*24;
					let nextMonth;
					
					if(month==12) {
						nextMonth = (year+1)+'/'+"1";
					}else {
						nextMonth = year+'/'+(month+1);
					}
					this.date.yearPeriodsEnd = new Date(nextMonth).getTime()-oneDay;
				}
				this.getTableList();
			},
			// 科目、条件改变
			handleDateChange(val) {
				this.getTableList();
			},
			// 科目改变请求表格数据
			handleSelectChange(val) {
				this.form.subjectId = val;
				this.getTableList();
			},
			// 翻页
			handlePaginationChange (data) {
				const { pageNo, pageSize } = data;

				if (pageNo) { 
					this.$set(this.form, 'currentPage', pageNo);
					this.$set(this.tableData.page, 'pageNo', pageNo);
				}

				if (pageSize) {
					this.$set(this.form, 'maxResult', pageSize);
					this.$set(this.tableData.page, 'pageSize', pageSize);
				}
				this.getTableList();
			},
			// 点击进出账
			handleCilckChange(row) {
				let _ = this;
				// if(_.nowTypeID_money == 1 || _.nowTypeID_money == 2) {
				// 	return;
				// }
				if(_.nowID == row.id) {
					_.tableData.config.forEach(item=>{
						item.show = 'normal';
					})
					_.nowID = '';
					_.form.accountType='';
					_.getTableList();
				}else {
					if(row.id==22) {
						// 出账点击
						_.tableData.config.forEach(item=>{
							if(item.value == 'debit_money') {
								item.show = false;
							}else {
								item.show = 'normal';
							}
						})
					}else if(row.id == 11) {
						// 进账点击
						_.tableData.config.forEach(item=>{
							if(item.value == 'creditor_money') {
								item.show = false;
							}else {
								item.show = 'normal';
							}
						})
					}
					_.nowID = row.id;
					_.form.accountType = row.accountType;
					_.getTableList();
				}
			},
			

			// 科目
			getSubjectTree(id) {
				let _=this;
				try {
					_.$http.post('MoneyOverview/getSubjectTree',{subjectId:id}).then(res=>{
						if(res&&res.data.code==1) {
							_.getSubjectTreeList = res.data.data;
							_.form.subjectId = res.data.data[0].id;	
							this.getTableList();					}
					})
				}catch(e) {

				}
			},
			// 获取表格数据POST /MoneyOverview/findFundsDetails
			getTableList() {
				let _=this;
				_.form.startTime = _.$util.formatDate.format(_.date.yearPeriodsStart , 'yyyy-MM-dd');
				 _.form.endTime = _.$util.formatDate.format(_.date.yearPeriodsEnd , 'yyyy-MM-dd');
				try {
					_.tableData.loading = true;
					_.$http.post('MoneyOverview/findFundsDetails',_.form).then(res=>{
						if(res&&res.data.code==1) {
							_.tableData.data = res.data.data.list.map(i=>{
								i.debit_money = currencys(i.debit_money);
								i.creditor_money = currencys(i.creditor_money);
								i.remaining_sum = currencys(i.remaining_sum);
								return i;
							});
							if(res.data.data.list.length) {
								_.tableData.hasShowPagination = true;
							}else {
								_.tableData.hasShowPagination = false;
							}
							_.tableData.page=Object.assign(_.tableData.page,{
								pageNo: res.data.data.currentPage,
								pageSize: res.data.data.maxResult,
								count: res.data.data.total
							})
							_.tableData.loading = false;
								// 进账
								_.JCXlist[0].money =  currencys(res.data.data.inAccountTotal);
								// 出账
								_.JCXlist[1].money =  currencys(res.data.data.outAccountTotal);
						}
					})
				}catch(e) {
					_.tableData.loading = false;
				}
			},
			
		},
		watch: {
			showVisible(val) {
				if(val) {
					this.date.yearPeriodsStart = this.period_date_start;
					this.date.yearPeriodsEnd = this.period_date_end;
					if(this.nowTypeID_money == 3 || this.nowTypeID) {
						this.nowID = null;
						this.form.accountType = '';
						this.tableData.config.forEach(item=>{
							if(item.value == 'debit_money' || item.value == 'creditor_money') {
								item.show = 'normal';
							}
						})
						// 总余额点击
					}else if(this.nowTypeID_money == 2) {
						// 出账点击
						this.tableData.config.forEach(item=>{
							if(item.value == 'debit_money') {
								item.show = false;
							}else {
								item.show = 'normal';
							}
						})
						this.nowID = this.JCXlist[1].id;
						this.form.accountType = this.JCXlist[1].accountType;
						
					}else {
						// 进账点击
						this.tableData.config.forEach(item=>{
							if(item.value == 'creditor_money') {
								item.show = false;
							}else {
								item.show = 'normal';
							}
						})
						this.nowID = this.JCXlist[0].id;
						this.form.accountType = this.JCXlist[0].accountType;

					}
					
					this.getSubjectTree(this.nowTypeID);
				}
			}
		}
	}
</script>
<style lang='less'>
	#ZJ_dialog {
		.el-dialog__header {
			padding: .3rem .3rem 0;
		}
		.el-dialog__body {
			padding: .2rem 0rem .3rem;
		}
		.el-form--inline .el-form-item {
			margin-right: .2rem;
		}
		.el-form {
			padding: 0 .3rem .3rem;
			border-bottom: 1px solid #EEEEEE;
		}
		.el-form-item {
			margin-bottom:0;
		}
		.Lately_date {
			margin-left: .1rem;
			span {
				display: inline-block;
				margin: 0 .15rem;
				cursor: pointer;
				&:last-child{
					i{
						margin-left:.1rem;
					}
				};
			}
		}
		.ZJ_dialog_title {
			span {
				&:first-child {
					font-size:.16rem;
					color:#333;
					font-weight: bold;
				};
				&:last-child {
					font-size: .12rem;
					color: #ACB7C3;
				};
			}
		}
		.JCZ_item {
			padding: 0rem .3rem;
			.JCZ_item_ul {
				padding: .2rem 0rem;
				.JCZ_item_li{
					cursor: pointer;
					padding:.1rem .24rem .1rem .12rem;
					box-sizing: border-box;
					text-align: center;
					display: inline-block;
					border: 1px solid #E3E3E3;
					border-radius: 5px;
					color:#666;
					&:last-child{
						margin-left: .18rem;
					};
				}
				.active_jcz {
					background: #107EF2;
					color: #fff;
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/dialog/ZjDialog.vue